


import { Snackbar } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import { useNavigate } from "react-router-dom";
import UOMService from "../../../../services/Production/UOMService";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import UtilsFormule from "../../../../utils/UtilsFormule";
import withLoader from "../../../../components/layouts/WithLoader";



const AllUnitOfMesure = ({ startLoading, stopLoading }) => {

    const navigate = useNavigate();
    const [availableUOM, setAvailableUOM] = useState([]);
    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [errorAlertText, setErrorAlertText] = useState();

    const onAddWorkStationHandler = () => {
        navigate(`/uom/new`);
    };

    useEffect(() => {
        startLoading();
        UOMService.allUnitOfMesure(getCurrentUserId())
            .then((response) => {
                console.log("response", response)
                if (response.data.success) {
                    setAvailableUOM(response.data.success);
                } else if (response.data.empty) {
                    // setAvailableUOM(response.data.success);
                } else {
                    // setOpenErrorAlert(true);
                    // setErrorAlertText("Erreur : pas de nomenclature");
                }
            })
            .catch((e) => {
                console.log("error", e);
            }).finally(() => {
                stopLoading();
            });
    }, []);
    const handleEroorClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenErrorAlert(false);
    };
    return (
        <div className="content-wrapper" style={{ marginTop: "0" }}>
            <div className="content">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-12">
                            <div class="card  mt-3">
                                <div class="card-body">
                                    <h5 class="card-title">Les unités de mesure</h5>
                                    <button
                                        class="btn btn-dark float-right"
                                        data-toggle="modal"
                                        data-target="#add-brand"
                                        onClick={onAddWorkStationHandler}
                                    >
                                        <i class="fas fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                            <section class="content">
                                <div class="card">
                                    <div class="card-header  ">
                                        <h3 class="card-title">Les unités de mesure</h3>
                                        <div class="card-tools">
                                            <button
                                                type="button"
                                                class="btn btn-tool"
                                                data-card-widget="collapse"
                                                title="Collapse"
                                            >
                                                <i class="fas fa-minus"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="card-body p-0">
                                        <table class="table  projects">
                                            <thead>
                                                <tr>
                                                    <th>Code</th>
                                                    <th>Libellé</th>

                                                    <th style={{ width: "12%" }}>DC</th>

                                                    {/* <th className="text-center" style={{ width: "12%" }}>
                                                        Voir Plus
                                                    </th> */}

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {availableUOM &&
                                                    availableUOM.map((element, i) => (
                                                        <tr key={element.id}>
                                                            <td>{element.code}</td>
                                                            <td>{element.name}</td>
                                                            <td>{UtilsFormule.formatDate(element.dateCreation)}</td>
                                                            {/* <td className="text-center">
                                                                <button
                                                                    style={{ width: 40 }}
                                                                    class="btn btn-dark btn-sm"
                                                                    onClick={() => {
                                                                        sessionStorage.setItem("idUOM", element.id);
                                                                        navigate(`/uom/details`)
                                                                    }
                                                                    }
                                                                >
                                                                    <i class="fas fa-folder"></i>
                                                                </button>
                                                            </td> */}
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
            <Snackbar
                open={openErrorAlert}
                autoHideDuration={2000}
                onClose={handleEroorClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleEroorClose} severity="error">
                    {errorAlertText}
                </Alert>
            </Snackbar>
        </div>
    )

}
export default withLoader(AllUnitOfMesure);

